// export default function ButtonComponent({ style, content, url, outerStyle }) {
//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "left",
//         alignItems: "center",
//         width: "100%",
//       }}
//     >
//       <a href={url}>
//         <button style={style}>{content}</button>
//       </a>
//     </div>
//   );
// }

// export default function ButtonComponent({ style, content, url, outerStyle }) {
//   return (
//     <table
//       role="presentation"
//       width="100%"
//       cellSpacing="0"
//       cellPadding="0"
//       style={{ width: "100%" }}
//     >
//       <tr>
//         <td align="left" style={{ padding: "0" }}>
//           {/* Button wrapper table (email-safe) */}
//           <table
//             role="presentation"
//             cellSpacing="0"
//             cellPadding="0"
//             style={{ ...outerStyle }}
//           >
//             <tr>
//               <td
//                 align="center"
//                 valign="middle"
//                 style={{
//                   backgroundColor: style?.backgroundColor || "#4F46E5",
//                   padding: style?.padding || "12px 24px",
//                   borderRadius: style?.borderRadius || "4px",
//                   border: style?.border || "none",
//                 }}
//               >
//                 <a
//                   href={url}
//                   style={{
//                     color: style?.color || "#ffffff",
//                     fontSize: style?.fontSize || "16px",
//                     textDecoration: "none",
//                     fontWeight: style?.fontWeight || "bold",
//                     display: "inline-block",
//                   }}
//                 >
//                   {content}
//                 </a>
//               </td>
//             </tr>
//           </table>
//         </td>
//       </tr>
//     </table>
//   );
// }

export default function ButtonComponent({ style, content, url, outerStyle }) {
  const align = outerStyle?.align || "left";

  return (
    <table
      role="presentation"
      width="100%"
      cellSpacing="0"
      cellPadding="0"
      style={outerStyle}
    >
      <tr>
        <td align={align}>
          <table role="presentation" cellSpacing="0" cellPadding="0">
            <tr>
              <td
                style={{
                  backgroundColor: style.backgroundColor,
                  padding: style.padding,
                  borderRadius: style.borderRadius,
                  fontSize: style.fontSize,
                  fontWeight: style.fontWeight,
                  textAlign: style.textAlign,
                  color: style.color,
                  width: style.width || "auto",
                  ...(style.height && { height: style.height }), // optional
                }}
              >
                <a
                  href={url}
                  style={{
                    color: style.color,
                    textDecoration: "none",
                    display: "inline-block",
                  }}
                >
                  {content}
                </a>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  );
}
